import React from 'react'
import ScoringSystem from './ScoringSystem'

const GuidanceStep = () => {
    return (
        <div>
            <h3 className="mb-5 !text-3xl text-vivid_raspberry">
                SECURITY ASSESSMENT QUESTIONAIRE
            </h3>

            <p className="text-lg">
                Celerity’s Security Assessment analysis is based around the NIST
                Cyber Security Framework 2.0 and uses a scoring system based on
                the answers from its participants.
            </p>

            <ScoringSystem />
            <p className="my-4 text-lg">
                You should answer with a lower number if you feel activities the
                question asks about are less developed in your organisation or
                have lower levels of investment.{' '}
                <span className="text-vivid_raspberry italic">
                    For example, processes are less defined and procedures less
                    coordinated or informal. Security controls and tasks are
                    more manual.
                </span>
            </p>
            <p className="mb-8 text-lg">
                You should answer with a higher number score if you feel
                activities the question asks about are more mature in your
                organisation with a culture that supports continuous
                improvement.{' '}
                <span className="text-vivid_raspberry italic">
                    For example, processes are well defined or comprehensive,
                    taking a risk-based and data-led approach. Security controls
                    are implemented fully with high levels of technology
                    automation and integrate continuous feedback and
                    improvement.
                </span>
            </p>

            <p className="text-2xl font-bold text-vivid_raspberry">
                OK, Let’s start….
            </p>
        </div>
    )
}

export default GuidanceStep
